import request from "@/utils/request.js";
import {API_USERDOWNLOAD_ADD} from "@/constant/api.js";
import {Message} from "view-design";

/****
 * 文件上传
 * */
export function addUserDownloadApi(option) {
    return new Promise((resolve, reject) => {
        request(API_USERDOWNLOAD_ADD,option,{
            method:'POST'
        })
            .then((res) => {
                Message.success({
                    background: true,
                    content: '提交成功'
                });
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
}



// WEBPACK FOOTER //
// ./src/api/userdownload.js